import { render, staticRenderFns } from "./popularScience.vue?vue&type=template&id=39e01991&scoped=true&"
import script from "./popularScience.vue?vue&type=script&lang=js&"
export * from "./popularScience.vue?vue&type=script&lang=js&"
import style0 from "./popularScience.vue?vue&type=style&index=0&id=39e01991&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e01991",
  null
  
)

export default component.exports